import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 border-t border-navy-800 pt-10 pb-6 md:pt-16 md:pb-8 px-4 sm:px-6 lg:px-8" data-id="element-160">
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-161">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-white mb-2" data-id="element-162">
          PROFE DE VOLLEY <span className="text-gold-500" data-id="element-163">RESUELTO™</span>
        </h2>
        <p className="text-sm md:text-base text-gray-400 max-w-md mb-4 md:mb-8" data-id="element-164">
          El sistema de entrenamientos N°1 para profes de volley en Argentina.
          Porque entrenar volley no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-6 md:mb-12" data-id="element-165">
          <a href="mailto:soporte.activadigitalok@gmail.com" className="flex items-center gap-1.5 md:gap-2 text-gray-300 hover:text-gold-400 transition-colors text-xs md:text-base" data-id="element-166">
            <Mail className="w-4 h-4 md:w-5 md:h-5" data-id="element-167" />
            <span data-id="element-168">soporte.activadigitalok@gmail.com</span>
          </a>
          <a href="#" className="flex items-center gap-1.5 md:gap-2 text-gray-300 hover:text-gold-400 transition-colors text-xs md:text-base" data-id="element-169">
            <Instagram className="w-4 h-4 md:w-5 md:h-5" data-id="element-170" />
            <span data-id="element-171">@activadigital.store</span>
          </a>
          <a href="#" className="flex items-center gap-1.5 md:gap-2 text-gray-300 hover:text-gold-400 transition-colors text-xs md:text-base" data-id="element-172">
            <Globe className="w-4 h-4 md:w-5 md:h-5" data-id="element-173" />
            <span data-id="element-174">activadigital.store</span>
          </a>
        </div>

        <div className="w-full border-t border-navy-800 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-2 md:gap-4 text-[10px] md:text-xs text-gray-500" data-id="element-175">
          <p data-id="element-176">© Activa Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-177">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}